import { Link } from 'react-router-dom';
import { useRestaurantCart } from '@happyspace/sdk/restaurant';
import { ShoppingBag } from 'lucide-react';

export default function StickyOrderBar({ onCartOpen }: { onCartOpen: () => void }) {
  const { itemCount, total } = useRestaurantCart();
  if (itemCount === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden px-4 pb-4">
      <button
        onClick={onCartOpen}
        className="w-full btn-primary justify-between shadow-2xl"
      >
        <span className="flex items-center gap-2">
          <ShoppingBag size={18} />
          {itemCount} item{itemCount > 1 ? 's' : ''}
        </span>
        <span className="tabular-nums">${total.toFixed(2)}</span>
      </button>
    </div>
  );
}
